import api from "app/api";

export interface ProfileForm {
  email: string;
  first_name: string;
  last_name: string;
}

export interface ChangePasswordForm {
  password: string;
  newPassword: string;
}

export async function loadProfile() {
  return await api.get("/user/profile");
}

export async function updateProfile(item: ProfileForm) {
  return await api.post("/user/update", { ProfileForm: item });
}

export async function changePassword(item: ChangePasswordForm) {
  return await api.post("/user/change-password", { ChangePasswordForm: item });
}
